import { Translation } from "./Translation"
import { HOSTED_APP_BODY_CLASS } from "../../server/hosted/HostedConstants"

const PWA_DISMISS_KEY = "pwa-install-dismissed"
const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000 // 7 days
const TRANSLATION_ID = "PwaInstall"

export class PwaInstall {
  private deferredPrompt: any = null
  private banner: HTMLElement | null = null
  private translation = new Translation()

  setup() {
    if (document.body.classList.contains(HOSTED_APP_BODY_CLASS)) return

    // Don't show if already installed (standalone mode)
    if (window.matchMedia("(display-mode: standalone)").matches) return
    if ((navigator as any).standalone === true) return

    this.translation.fetchTranslations(TRANSLATION_ID)

    window.addEventListener("beforeinstallprompt", (event: Event) => {
      event.preventDefault()
      this.deferredPrompt = event

      // Check if user dismissed recently
      const dismissedAt = localStorage.getItem(PWA_DISMISS_KEY)
      if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < DISMISS_DURATION_MS) return

      this.showBanner()
    })
  }

  private async showBanner() {
    // Don't stack a second banner if one is already shown
    if (this.banner || document.querySelector(".pwa-install-banner")) return

    if (this.translation.isEmpty()) {
      await this.translation.fetchTranslations(TRANSLATION_ID)
    }

    const t = this.translation.t
    this.banner = document.createElement("div")
    this.banner.className = "pwa-install-banner"
    this.banner.innerHTML = `
      <div class="pwa-install-banner-content">
        <img src="/client/assets/favicon.svg" alt="Restanaut" class="pwa-install-icon" />
        <div class="pwa-install-text">
          <strong>${t("Install Restanaut")}</strong>
          <span>${t("Add to your home screen for quick access")}</span>
        </div>
        <div class="pwa-install-actions">
          <button class="btn btn-sm btn-primary pwa-install-btn">${t("Install")}</button>
          <button class="btn btn-sm btn-outline-secondary pwa-install-dismiss">&times;</button>
        </div>
      </div>
    `

    document.body.appendChild(this.banner)

    // Animate in
    requestAnimationFrame(() => {
      this.banner?.classList.add("pwa-install-banner--visible")
    })

    this.banner.querySelector(".pwa-install-btn")?.addEventListener("click", async () => {
      if (!this.deferredPrompt) return
      this.deferredPrompt.prompt()
      await this.deferredPrompt.userChoice
      this.deferredPrompt = null
      this.removeBanner()
    })

    this.banner.querySelector(".pwa-install-dismiss")?.addEventListener("click", () => {
      localStorage.setItem(PWA_DISMISS_KEY, Date.now().toString())
      this.removeBanner()
    })
  }

  private removeBanner() {
    if (!this.banner) return
    this.banner.classList.remove("pwa-install-banner--visible")
    this.banner.addEventListener("transitionend", () => this.banner?.remove())
    this.banner = null
  }
}
